import * as React from "react";
import { cn } from "@/lib/utils";

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  illustration?: React.ReactNode;
  title: React.ReactNode;
  body?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ illustration, title, body, action, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex flex-col items-center justify-center gap-4 rounded-xl border border-dashed border-border-1 bg-surface-2/40 px-6 py-12 text-center",
        className,
      )}
      {...props}
    >
      {illustration && <div className="text-text-3" aria-hidden>{illustration}</div>}
      <div className="space-y-1.5 max-w-md">
        <h3 className="t-display-sm text-text-1">{title}</h3>
        {body && <p className="t-body-sm text-text-3">{body}</p>}
      </div>
      {action && <div className="pt-2">{action}</div>}
    </div>
  ),
);
EmptyState.displayName = "EmptyState";
